import { DOP_CONFIG } from '../config/dopConfig';

const Step3Debljine = ({ formData, setFormData }: any) => {

    const toggle = (val: number) => {
        const exists = formData.debljine.includes(val);

        setFormData((prev: any) => ({
            ...prev,
            debljine: exists
                ? prev.debljine.filter((d: number) => d !== val)
                : [...prev.debljine, val]
        }));
    };

    return (
        <div>

            {/* HEADER */}
            <div className="text-center mb-6">
                <h3 className="fw-bold">Odaberi debljine panela</h3>
                <div className="text-muted">
                    Možete odabrati jednu ili više debljina
                </div>
            </div>

            {/* GRID */}
            <div className="row g-4 justify-content-center">

                {DOP_CONFIG.debljinePanel.map((d) => {
                    const isSelected = formData.debljine.includes(d);

                    return (
                        <div key={d} className="col-6 col-sm-4 col-md-3 col-lg-2">

                            <div
                                className={`card cursor-pointer text-center border ${
                                    isSelected ? 'border-primary bg-light-primary' : 'border-gray-300'
                                }`}
                                style={{
                                    transition: 'all 0.2s ease',
                                    transform: isSelected ? 'scale(1.05)' : 'scale(1)'
                                }}
                                onClick={() => toggle(d)}
                            >

                                <div className="card-body p-4">

                                    {/* VALUE */}
                                    <div className="fw-bold fs-3 mb-1">
                                        {d}
                                    </div>

                                    <div className="text-muted fs-7">
                                        mm
                                    </div>

                                    {/* CHECK */}
                                    {isSelected && (
                                        <div className="mt-2">
                                            <i className="ki-duotone ki-check-circle fs-2 text-primary"></i>
                                        </div>
                                    )}

                                </div>
                            </div>

                        </div>
                    );
                })}
            </div>

            {/* SELECTED SUMMARY */}
            {formData.debljine.length > 0 && (
                <div className="mt-6 text-center">

                    <div className="text-muted mb-2">
                        Odabrane debljine:
                    </div>

                    <div className="d-flex flex-wrap justify-content-center gap-2">
                        {formData.debljine.map((d: number) => (
                            <span key={d} className="badge badge-light-primary fs-6 px-3 py-2">
                {d} mm
              </span>
                        ))}
                    </div>

                </div>
            )}

        </div>
    );
};

export default Step3Debljine;